import { render } from "./MyHeader.vue?vue&type=template&id=7c91fd53"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/cpaps/dev2-sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__